import { useEnvironment } from '~/composables/useEnvironment';

/**
 * Middleware to protect staging-only routes from production access
 *
 * Routes using this middleware will redirect to the appropriate home page when accessed in production:
 * - LMS routes (/lms/*) redirect to /lms
 * - Landing site routes redirect to /
 *
 * @example
 * definePageMeta({
 *   middleware: ['staging-only']
 * });
 */
export default defineNuxtRouteMiddleware((to, from) => {
   const { isProduction } = useEnvironment();

   if (isProduction.value) {
      const redirectPath = to.path.startsWith('/lms') ? '/lms' : '/';
      return navigateTo(redirectPath);
   }
});
